import React from 'react'
import Dudu from './../images/dudu'
import Renato from './../images/renato'


const depoimentos = [
    {
      name: 'Eduardo Luiz',
      cargo: 'Diretor de operações',
      social_link: 'https://www.linkedin.com/in/eduardo-luiz-soares-carneiro-60a31964/',
      key: 'dudu',
      img: <Dudu />,
      icon: 'fal fa-chart-line',
      description: '"O TagPlus 2.0 foi desenvolvido focando 100% na experiência de uso, garantindo a facilidade na jornada de ações do sistema."'
    },
    {
      name: 'Renato Trindade',
      cargo: 'Diretor de Tecnologia',
      social_link: 'https://www.linkedin.com/in/renato-trindade-ribeiro-ab09ab31/',
        key: 'renato',
        img: <Renato />,
        icon: 'far fa-cog',
        description: '"Nossa equipe de design e desenvolvimento trabalhou com ímpeto para entregar um produto de alto nível."'
      },
     
    
  ]
  export {
    depoimentos 
  }